import i18n from '@/i18n'

export default class InvalidCredentialsError extends Error {
  super (
    message: string
  ){}

  static createError (message: string | null): InvalidCredentialsError {
    return new InvalidCredentialsError(
      message ? message : i18n.t('errors.invalidCredentials') as string
    )
  }
}
